export const SHIPPING_SUMMARY_COLUMNS = [
  { key: 'JobNumber', label: 'Job Number' },
  { key: 'ProjectName', label: 'Job Name' },
  { key: 'Destination', label: 'Destination' },
  { key: 'TransportMode', label: 'Truck Type' },
  { key: 'SummaryShipDate', label: 'Ship Date', type: 'date' },
  { key: 'DeliveryDate', label: 'Delivery Date', type: 'date' },
  { key: 'Shipped', label: 'Shipped' },
  { key: 'SelectedTransporter', label: 'Transporter' },
  { key: 'FreightCost', label: 'Freight Cost', type: 'currency' },
];

const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (character) => ({
  '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
}[character]));
export function buildShippingSummary(rows, formatValue) {
  const intro = 'Below is the shipping summary for the jobs in the selected schedule view, including any overdue unshipped jobs.';
  const cells = rows.map((row) => SHIPPING_SUMMARY_COLUMNS.map(({ key, type }) => {
    const value = key === 'SummaryShipDate' ? String(row.ActualShipDate ?? '').trim() || row.CurrentPlanShipDate : row[key];
    return value == null || String(value).trim() === '' ? (type === 'date' ? 'TBD' : '—') : formatValue(value, type);
  }));
  const headerStyle = 'border:1px solid #8b99a7;padding:8px;background:#e9f0f7;text-align:left;';
  const cellStyle = 'border:1px solid #8b99a7;padding:8px;vertical-align:top;';
  const html = `<html><head><meta charset="utf-8"></head><body style="font-family:Arial,sans-serif;font-size:11pt;"><p>Team,</p><p>${intro}</p><table style="border-collapse:collapse;"><thead><tr>${SHIPPING_SUMMARY_COLUMNS.map(({ label }) => `<th style="${headerStyle}">${label}</th>`).join('')}</tr></thead><tbody>${cells.map((values) => `<tr>${values.map((value) => `<td style="${cellStyle}">${escapeHtml(value)}</td>`).join('')}</tr>`).join('')}</tbody></table></body></html>`;
  const plainText = ['Team,', intro, ...cells.map((values) => values
    .map((value, index) => `${SHIPPING_SUMMARY_COLUMNS[index].label}: ${value}`).join('\r\n'))].join('\r\n\r\n');
  return { intro, cells, html, plainText };
}
